import { render, staticRenderFns } from "./PitchDays.vue?vue&type=template&id=213e0548&scoped=true"
import script from "./PitchDays.vue?vue&type=script&lang=js"
export * from "./PitchDays.vue?vue&type=script&lang=js"
import style0 from "./PitchDays.vue?vue&type=style&index=0&id=213e0548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e0548",
  null
  
)

export default component.exports